import React, {useState, useEffect} from "react";
import {
  Form,
  FormGroup,
  ListGroup,
  ListGroupItem,
  Spinner,
  Row,
  Col
} from "reactstrap";
import PieChart from "react-minimal-pie-chart";
import PropTypes from "prop-types";

import {PieChartColors} from "../../Account/types";
import CircularProgress from "../../../CircularProgress/CircularProgress";

const PortfolioTab = ({person, portfolio, handleRedirectAccount, services, opsViewAccountName}) => {
  const [accountPortfolios, setAccountPortfolios] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const body = {
      personId: person.PersonId
    };
    services.fetchGetPersonAccountPorfolios(body, response => {
      setLoading(false);
      setAccountPortfolios(response.portfolio);
    });
  }, []);

  if (loading) {
    return <CircularProgress sm />;
  }

  return (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          <ListGroup>
            {accountPortfolios.map(port => {
              const portfolioSlices = port.Portfolio.map((p, index) => ({
                title: p.AssetTicker,
                value: parseFloat(p.PortfolioQuantity),
                color: PieChartColors[index % PieChartColors.length]
              }));
              return (
                <ListGroupItem
                  onClick={() => handleRedirectAccount(port.AccountId)}
                  key={port.AccountId}
                >
                  <Row style={{fontSize: "15px", fontWeight: 500}}>
                  {
                    opsViewAccountName !== undefined ?
                    (
                      opsViewAccountName ?
                      <Col>{`${port.AccountName + "-" + port.AccountNumber}`}</Col>
                      :
                      <Col>{`${port.AccountNumber}`}</Col>
                    )
                    :
                    <Col>{`${port.AccountName + "-" + port.AccountNumber}`}</Col>
                  }
                    <Col>{port.AccountRelationship}</Col>
                    <Col>
                      <PieChart
                        style={{width: "50px", height: "50px", marginLeft: 0}}
                        data={portfolioSlices}
                      />
                    </Col>
                  </Row>
                </ListGroupItem>
              );
            })}
          </ListGroup>
        </FormGroup>
      </Form>
    </div>
  );
};

PortfolioTab.propTypes = {
  portfolio: PropTypes.array,
  handleRedirectAccount: PropTypes.func.isRequired
};

PortfolioTab.defaultProps = {
  portfolio: undefined
};

export default PortfolioTab;
